import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Field } from '../../../../../../model';
import { LoginService } from '../../../../../../services/login.service';
import { ErpWarehouseService } from '../../../../../../services/erp/erp-warehouse.service';

@Component({
  selector: 'app-product-list-help-menu',
  standalone: false,
  templateUrl: './product-list-help-menu.component.html',
  styleUrl: './product-list-help-menu.component.css',
})
export class ProductListHelpMenuComponent {
  erpWarehouseService = inject(ErpWarehouseService);
  loginService = inject(LoginService);

  @Input() disabled = false;
  @Input() selectedColumns!: string[];
  @Input() gridCols!: any[];
  @Input() product_fields!: Field[];
  @Input() entCode: string;
  @Output() totalDisc = new EventEmitter<number>();
  @Output() defaultWarehouse = new EventEmitter<number>();
  @Output() exportOnExcel = new EventEmitter<boolean>();
  @Output() updateSelectedColumnsEv = new EventEmitter<any>();

  warehouses = this.erpWarehouseService.productListWarehouses;
  defaultWarehouseId: number | null = null;
  totalDiscount = 0;

  changeTotalDisc() {
    this.totalDisc.emit(this.totalDiscount);
  }

  changeDefaultWarehouse() {
    this.defaultWarehouse.emit(this.defaultWarehouseId);
  }

  onExportToExcel() {
    this.exportOnExcel.emit(true);
  }

  updateSelectedColumns($event: any) {
    this.updateSelectedColumnsEv.emit($event);
  }
}
